import axios from 'axios';

const showPackageFields = function (target) {
  const weighed = $(target).prop('checked');
  const row = $(target).parents('tr');
  const ticketItemUnit = row.find('.ticket_item_unit');
  const presentationAmountField = row.find(
    '.ticket_item_presentation_amount_field'
  );
  const amountField = row.find('.ticket_item_amount_field');
  ticketItemUnit.toggleClass('d-none', weighed);
  presentationAmountField.toggleClass('d-none', weighed);
  amountField.attr('readonly', !weighed);
};

const calculateTotalPackageAmount = async (
  presentationAmountField,
  amountField,
  currentUnitId,
  productId,
  lotCode
) => {
  if (!currentUnitId === false) {
    const params = {};
    params.current_unit_id = currentUnitId;
    params.product_id = productId;

    if ($('#load_order_items_table').val() !== undefined) {
      params.lot_id = lotCode;
    } else {
      params.lot_code = lotCode;
    }

    try {
      const res = await axios.get('/unit_conversion_factor.json', {
        params,
      });
      const conversionFactor = res.data;
      const convertedAmount =
        parseFloat(presentationAmountField.val()) * conversionFactor;
      if (!convertedAmount.isNaN && convertedAmount.length !== 0) {
        amountField.val(convertedAmount.toFixed(4));
      } else {
        amountField.val(0);
      }
    } catch (error) {
      console.log(error);
    }
  }
};

const updateTotalAmount = function (target) {
  const row = $(target).parents('tr');
  const weighed = row.find('.weighed_checkbox').prop('checked');

  if (weighed === false) {
    const lotCode = row.find('.lot_select').val();

    let productId;
    const ticketProductId = row.find('.ticket_item_product_id').val();
    const purchaseOrderProductId = row
      .find('.purchase_order_product_select')
      .val();

    if (
      purchaseOrderProductId !== '' &&
      purchaseOrderProductId !== null &&
      purchaseOrderProductId !== undefined
    ) {
      productId = purchaseOrderProductId;
    } else {
      productId = ticketProductId;
    }

    const currentUnitId = row.find('.ticket_item_unit_select').val();
    const presentationAmountField = row.find(
      '.ticket_item_presentation_amount_field'
    );
    const amountField = row.find('.ticket_item_amount_field');

    calculateTotalPackageAmount(
      presentationAmountField,
      amountField,
      currentUnitId,
      productId,
      lotCode
    );
  }
};

const updateProductMeasurementUnitSelect = async target => {
  const row = $(target).parents('tr');
  const measurementUnitSelect = row.find('.ticket_item_unit_select');
  const ticketProductSelect = row.find('.ticket_item_product_id');
  const loadOrderProductSelect = row.find('.load_order_product_select');
  const purchaseOrderProductSelect = row.find('.purchase_order_product_select');
  let productId = undefined;

  if (ticketProductSelect.length) {
    productId = ticketProductSelect.val();
  } else if (loadOrderProductSelect.length) {
    productId = loadOrderProductSelect.val();
  } else {
    productId = purchaseOrderProductSelect.val();
  }

  // If a product is selected, update the measurementUnitSelect with the product unit
  if (productId !== '' && productId !== null && productId !== undefined) {
    try {
      const res = await axios.get('/product_group_measurement_units.json', {
        params: { product_id: productId },
      });
      const units = res.data;
      measurementUnitSelect.empty();
      units.forEach(function (unit) {
        measurementUnitSelect.append(
          $('<option>', {
            text: unit.name,
            value: unit.id,
          })
        );
      });
      measurementUnitSelect.trigger('change');
    } catch (error) {
      console.log(error);
    }
  }
};

const updateProductUnitName = async (td, tr) => {
  const row = tr === '' ? $(td).parents('tr') : $(tr);
  const productUnitName = row.find('.product_unit_name');
  const productId = row.find('.purchase_order_product_select').val();
  if (productId !== '' && productId !== null && productId !== undefined) {
    try {
      const res = await axios.get('/product_measurement_unit.json', {
        params: { product_id: productId },
      });
      productUnitName.text(res.data.name);
      productUnitName.removeClass('d-none', true);
    } catch (error) {
      console.log(error);
    }
  }
};

const updateProductSelect = async target => {
  const row = $(target).parents('tr');
  const weighed = row.find('.weighed_checkbox').prop('checked');
  const purchaseOrderProductSelect = row.find('.purchase_order_product_select');
  const loadOrderProductSelect = row.find('.load_order_product_select');
  const ticketProductSelect = row.find('.ticket_item_product_id');
  let productSelect = undefined;

  if (ticketProductSelect.length) {
    productSelect = ticketProductSelect;
  } else if (loadOrderProductSelect.length) {
    productSelect = loadOrderProductSelect;
  } else {
    productSelect = purchaseOrderProductSelect;
  }

  try {
    const res = await axios.get('/weighed_products.json', {
      params: { weighed: weighed === true ? 'weighed' : 'not weighed' },
    });
    productSelect.empty();
    res.data.forEach(function (product) {
      productSelect.append(
        $('<option>', {
          text: product.code_and_name,
          value: product.id,
        })
      );
    });
    productSelect.prop('selectedIndex', -1);
    productSelect.trigger('change');
  } catch (error) {
    console.log(error);
  }
};

const updateMeasurementUnitSelect = async target => {
  const row = $(target).parents('tr');
  const measurementUnitSelect = row.find('.ticket_item_unit_select');
  const productId = row.find('.ticket_item_product_id').val();
  const lotId = row.find('.lot_select').val();

  if (productId !== '' && productId !== null && productId !== undefined) {
    try {
      const res = await axios.get('/product_group_measurement_units.json', {
        params: { product_id: productId },
      });
      const units = res.data;
      measurementUnitSelect.empty();
      units.forEach(function (unit) {
        measurementUnitSelect.append(
          $('<option>', {
            text: unit.name,
            value: unit.id,
          })
        );
      });
      measurementUnitSelect.trigger('change');
    } catch (error) {
      console.log(error);
    }
  } else if (lotId !== '' && lotId !== null && lotId !== undefined) {
    // If a lot is selected, update the measurementUnitSelect with the lot unit
    try {
      const res = await axios.get('/product_lot_group_measurement_units.json', {
        params: { product_lot_id: lotId },
      });
      const units = res.data;
      measurementUnitSelect.empty();
      units.forEach(function (unit) {
        measurementUnitSelect.append(
          $('<option>', {
            text: unit.name,
            value: unit.id,
          })
        );
      });
      measurementUnitSelect.trigger('change');
    } catch (error) {
      console.log(error);
    }
  }
};

const updateLotUnitName = async (td, tr) => {
  const row = tr === '' ? $(td).parents('tr') : $(tr);
  const productLotCode = row.find('.lot_select').val();
  const productLotId = row.find('.load_order_lot_select').val();
  const productId = row.find('.ticket_item_product_id').val();
  const lotUnitName = row.find('.lot_unit_name');

  if (
    productLotId !== '' &&
    productLotId !== null &&
    productLotId !== undefined
  ) {
    try {
      const res = await axios.get('/product_lot_measurement_unit.json', {
        params: { product_lot_id: productLotId },
      });
      lotUnitName.text(res.data.name);
      lotUnitName.removeClass('d-none', true);
    } catch (error) {
      console.log(error);
    }
  } else if (
    productLotCode !== '' &&
    productLotCode !== null &&
    productLotCode !== undefined
  ) {
    try {
      const res = await axios.get('/product_lot_measurement_unit.json', {
        params: { product_lot_code: productLotCode, product_id: productId },
      });
      lotUnitName.text(res.data.name);
      lotUnitName.removeClass('d-none', true);
    } catch (error) {
      console.log(error);
    }
  } else if (
    productId !== '' &&
    productId !== null &&
    productId !== undefined
  ) {
    try {
      const res = await axios.get('/product_measurement_unit.json', {
        params: { product_id: productId },
      });
      lotUnitName.text(res.data.name);
      lotUnitName.removeClass('d-none', true);
    } catch (error) {
      console.log(error);
    }
  }
};

const updateLotSelect = async target => {
  const row = $(target).parents('tr');
  const weighed = row.find('.weighed_checkbox').prop('checked');
  const lotSelect = row.find('.lot_select');
  const loadOrderProductId = row.find('.load_order_product_select').val();
  const productId = row.find('.ticket_item_product_id').val();

  if (
    loadOrderProductId !== '' &&
    loadOrderProductId !== undefined &&
    loadOrderProductId !== null
  ) {
    try {
      const res = await axios.get('/weighed_lots_by_product.json', {
        params: {
          weighed: weighed === true ? 'weighed' : 'not weighed',
          product_id: loadOrderProductId,
        },
      });
      lotSelect.empty();
      res.data.forEach(function (lot) {
        lotSelect.append(
          $('<option>', {
            text: lot.code,
            value: lot.id,
          })
        );
      });
      lotSelect.prop('selectedIndex', -1);
      lotSelect.trigger('change');
    } catch (error) {
      console.log(error);
    }
  } else if (
    productId !== '' &&
    productId !== undefined &&
    productId !== null
  ) {
    let dispatchTiket = $('#ticket_ticket_type_dispatch').prop('checked');
    const ticketTypeName = $('#ticket_type').text();
    if (dispatchTiket === undefined && ticketTypeName === 'Despacho') {
      dispatchTiket = true;
    }
    if (dispatchTiket === undefined && ticketTypeName === 'Recepción') {
      dispatchTiket = false;
    }

    try {
      const res = await axios.get('/weighed_lots_by_product.json', {
        params: {
          weighed: weighed === true ? 'weighed' : 'not weighed',
          product_id: productId,
        },
      });
      lotSelect.empty();
      res.data.forEach(function (lot) {
        lotSelect.append(
          $('<option>', {
            text: lot.code,
            value: dispatchTiket === true ? lot.id : lot.code,
          })
        );
      });
      lotSelect.prop('selectedIndex', -1);
      lotSelect.trigger('change');
    } catch (error) {
      console.log(error);
    }
  }
};

const hideLotModalButton = function () {
  let dispatchTiket = $('#ticket_ticket_type_dispatch').prop('checked');
  const ticketTypeName = $('#ticket_type').text();
  if (dispatchTiket === undefined && ticketTypeName === 'Despacho') {
    dispatchTiket = true;
  }
  if (dispatchTiket === undefined && ticketTypeName === 'Recepción') {
    dispatchTiket = false;
  }
  $('.lot-modal-button').toggleClass('d-none', dispatchTiket);
  $('.ticket_lot_code_select').toggleClass('d-none', dispatchTiket);
  $('.ticket_lot_id_select').toggleClass('d-none', !dispatchTiket);
};

const changeOnLotSelect = function () {
  const target = $(this);
  if ($('.load_order_lot_select').length) {
    updateMeasurementUnitSelect(target);
  }
  updateLotUnitName(target, '');
};

const changeOnProductSelect = function (target) {
  updateProductMeasurementUnitSelect(target);
  updateProductUnitName(target, '');
};

const toggleLotModal = async target => {
  const row = $(target).parents('tr');
  const lotModal = row.find('.lot-modal');
  lotModal.modal('show');
  row.find('.create-lot-button').on('click', function () {
    lotModal.modal('hide');
  });
};

const resetHiddenFields = function () {
  $('#ticket_items_table > tr').each(function (index, tr) {
    // Clear the presentation fields if the product is weighed on submit
    const row = $(tr);
    if (row.find('.weighed_checkbox').is(':checked')) {
      row.find('.ticket_item_unit_select').val('');
      row.find('.ticket_item_unit_select').trigger('change');
      row.find('.ticket_item_presentation_amount_field').val('');
      row.find('.ticket_item_presentation_amount_field').trigger('change');
    }
    // Clear the hidden lot select on submit
    let dispatchTiket = $('#ticket_ticket_type_dispatch').prop('checked');
    const ticketTypeName = $('#ticket_type').text();
    if (dispatchTiket === undefined && ticketTypeName === 'Despacho') {
      $('.ticket_lot_code_select').val('');
      $('.ticket_lot_code_select').trigger('change');
    }
    if (dispatchTiket === undefined && ticketTypeName === 'Recepción') {
      $('.ticket_lot_id_select').val('');
      $('.ticket_lot_id_select').trigger('change');
    }
  });
};

const setTicketItemFields = function (row) {
  const weighed = row.find('.weighed_checkbox').prop('checked');
  const ticketItemUnit = row.find('.ticket_item_unit');
  const presentationAmountField = row.find(
    '.ticket_item_presentation_amount_field'
  );
  const amountField = row.find('.ticket_item_amount_field');
  amountField.attr('readonly', !weighed);
  ticketItemUnit.toggleClass('d-none', weighed);
  presentationAmountField.toggleClass('d-none', weighed);
  updateLotUnitName('', row);
};

/****************************/
/******* ON PAGE LOAD *******/
/****************************/

document.addEventListener('turbolinks:load', function () {
  /*********** Select2 **********/

  $('.ticket_lot_field').select2({
    placeholder: 'Buscar un lote',
    width: '100%',
  });
  $('.ticket_lot_code_field').select2({
    tags: 'true',
    placeholder: 'Escribe un código',
    width: '100%',
    createTag: function (params) {
      var term = params.term.trim();

      if (term === '') {
        return null;
      }

      return {
        id: term,
        text: term,
        value: term,
      };
    },
  });
  $('.purchase_order_product_select').select2({
    placeholder: 'Buscar un producto (código o nombre)',
    minimumInputLength: 3,
    width: '100%',
  });
  $('.load_order_product_select').select2({
    placeholder: 'Buscar un producto (código o nombre)',
    minimumInputLength: 3,
    width: '100%',
  });
  $('.load_order_lot_select').select2({
    placeholder: 'Buscar un lote',
    width: '100%',
  });
  $('.ticket_item_product_id').select2({
    placeholder: 'Buscar un producto (código o nombre)',
    minimumInputLength: 3,
    width: '100%',
  });
  $('.ticket_item_plant_select').select2({
    placeholder: 'Seleccione una o varias plantas',
    width: '100%',
  });
  $('.ticket-item-location-select').select2({
    placeholder: 'Buscar por almacén, área o ubicación...',
    width: '100%',
  });

  /******** Modal for aditional lot attributes *******/

  hideLotModalButton();

  $('#ticket_ticket_type_dispatch').on('change', hideLotModalButton);
  $('#ticket_ticket_type_reception').on('change', hideLotModalButton);

  $('.lot-modal-button').on('click', function (e) {
    const target = $(e.currentTarget);
    toggleLotModal(target);
  });

  /********* Set Ticket Item Fields ********/

  $('#ticket_items_table > tr.nested-fields').each(function () {
    setTicketItemFields($(this));
  });

  $('#load_order_items_table > tr.nested-fields').each(function () {
    setTicketItemFields($(this));
  });
  $('#purchase_order_items_table > tr.nested-fields').each(function () {
    setTicketItemFields($(this));
  });

  /************* On Change ************/

  $('.ticket_item_unit_select').on('change', function (e) {
    const target = $(e.currentTarget);
    updateTotalAmount(target);
  });
  $('.ticket_item_presentation_amount_field').on('keyup', function () {
    updateTotalAmount($(this));
  });

  $('.weighed_checkbox').on('change', function (e) {
    const target = $(e.currentTarget);
    const row = $(target).parents('tr');

    updateProductSelect(target);

    updateLotUnitName(target, '');
    const unitSelect = row
      .find('.ticket_item_unit_select')
      .prop('selectedIndex', -1);
    unitSelect.trigger('change');
    row.find('.ticket_item_presentation_amount_field').val('');
    row.find('.ticket_item_amount_field').val('');
    row.find('.lot_select').empty();
    showPackageFields(target);
  });

  $('.ticket_item_product_id').on('change', function (e) {
    const target = $(e.currentTarget);
    updateLotSelect(target);
    changeOnProductSelect(target);
  });

  $('.load_order_product_select').on('change', function (e) {
    const target = $(e.currentTarget);
    updateLotSelect(target);
    changeOnProductSelect(target);
  });

  $('.lot_select').on('change', changeOnLotSelect);
  $('.purchase_order_product_select').on('change', function (e) {
    const target = $(e.currentTarget);
    changeOnProductSelect(target);
  });

  /*******************************************************************************/
  /* When a new ticket item is added (in Purchase Orders, Load Orders and Tickets) */
  /*******************************************************************************/

  $(
    '#load_order_items_table, #purchase_order_items_table, #ticket_items_table'
  ).on('cocoon:after-insert', function () {
    /*********** Select2 **********/
    $('select').select2({
      width: '100%',
    });
    $('.ticket_lot_field').select2({
      placeholder: 'Buscar un código de lote',
      width: '100%',
    });
    $('.ticket_lot_code_field').select2({
      tags: 'true',
      placeholder: 'Escribe un código',
      width: '100%',
      createTag: function (params) {
        var term = params.term.trim();

        if (term === '') {
          return null;
        }

        return {
          id: term,
          text: term,
          value: term,
        };
      },
    });
    $('.purchase_order_product_select').select2({
      placeholder: 'Buscar un producto (código o nombre)',
      minimumInputLength: 3,
      width: '100%',
    });
    $('.load_order_product_select').select2({
      placeholder: 'Buscar un producto (código o nombre)',
      minimumInputLength: 3,
      width: '100%',
    });
    $('.load_order_lot_select').select2({
      placeholder: 'Buscar un lote',
      width: '100%',
    });
    $('.ticket_item_product_id').select2({
      placeholder: 'Buscar un producto (código o nombre)',
      minimumInputLength: 3,
      width: '100%',
    });

    /******** Modal for aditional lot attributes *******/

    hideLotModalButton();
    $('#ticket_ticket_type_dispatch').on('change', hideLotModalButton);
    $('#ticket_ticket_type_reception').on('change', hideLotModalButton);

    $('.lot-modal-button').on('click', function (e) {
      const target = $(e.currentTarget);
      toggleLotModal(target);
    });

    /************* On Change ************/

    $('.lot_select').on('change', changeOnLotSelect);
    $('.purchase_order_product_select').on('change', function (e) {
      const target = $(e.currentTarget);
      changeOnProductSelect(target);
    });
    $('.ticket_item_unit_select').on('change', function (e) {
      const target = $(e.currentTarget);
      updateTotalAmount(target);
    });
    $('.ticket_item_presentation_amount_field').on('keyup', function () {
      updateTotalAmount($(this));
    });

    $('.weighed_checkbox').on('change', function (e) {
      const target = $(e.currentTarget);
      const row = $(target).parents('tr');

      updateProductSelect(target);

      updateLotUnitName(target, '');
      const unitSelect = row
        .find('.ticket_item_unit_select')
        .prop('selectedIndex', -1);
      unitSelect.trigger('change');
      row.find('.ticket_item_presentation_amount_field').val('');
      row.find('.ticket_item_amount_field').val('');
      row.find('.lot_select').empty();
      showPackageFields(target);
    });

    $('.load_order_product_select').on('change', function (e) {
      const target = $(e.currentTarget);
      updateLotSelect(target);
      changeOnProductSelect(target);
    });

    $('.ticket_item_product_id').on('change', function (e) {
      const target = $(e.currentTarget);
      updateLotSelect(target);
      changeOnProductSelect(target);
    });
  });

  // Clear hidden fields on submit
  $('.new_ticket').on('submit', resetHiddenFields);
  $('.edit_ticket').on('submit', resetHiddenFields);
});
